import { primaryGrey } from "../../constants/color";

const WheelPreview = ({ sliceColors, displayedSlices }) => {
  const visibleSlices = sliceColors.slice(0, displayedSlices);
  const anglePerSlice = 360 / visibleSlices.length;

  const buildConicGradient = () => {
    // Start from right side (0deg = 3 o'clock) going clockwise
    const stops = visibleSlices.map((color, i) => {
      const start = anglePerSlice * i;
      const end = anglePerSlice * (i + 1);
      return `${color} ${start}deg ${end}deg`;
    });
    return `conic-gradient(from 0deg, ${stops.join(", ")})`;
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      {/* Wheel with arrow */}
      <div style={{ position: "relative" }}>
        {/* Arrow pointer at top */}
        <div
          style={{
            position: "absolute",
            top: "-12px",
            left: "50%",
            transform: "translateX(-50%)",
            width: 0,
            height: 0,
            borderLeft: "10px solid transparent",
            borderRight: "10px solid transparent",
            borderTop: "14px solid #1B1C1E",
            zIndex: 2,
          }}
        />
        <div
          style={{
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background: buildConicGradient(),
            border: `5px solid ${primaryGrey}`,
            position: "relative",
          }}
        >
        {/* Center logo */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#fff",
            border: `2px solid ${primaryGrey}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <img
            src="/images/icon.png"
            alt="Logo"
            style={{
              width: "47px",
              height: "47px",
              objectFit: "contain",
            }}
          />
        </div>
        </div>
      </div>
    </div>
  );
};

export default WheelPreview;
